import React, { useId, useState } from "react";
import { portalGuides } from "../../data/portalGuides";
import "./PortalGuide.css";

export default function PortalGuide({ guideKey, darkMode = false, showDocumentationLink = false }) {
  const [search, setSearch] = useState("");
  const [topic, setTopic] = useState("");
  const searchId = useId();
  const guide = portalGuides[guideKey];
  const query = search.trim().toLowerCase();
  const sections = guide.sections.filter((section) =>
    (!topic || topic === section.id) &&
    (!query || [section.title, ...section.paragraphs].join(" ").toLowerCase().includes(query))
  );
  const reset = () => { setSearch(""); setTopic(""); };

  return (
    <div className={`portal-guide${darkMode ? " portal-guide-dark" : ""}`}>
      <p className="portal-guide-intro">{guide.intro}</p>
      <label className="portal-guide-search" htmlFor={searchId}>
        Search this guide
        <input id={searchId} type="search" value={search} placeholder="Search setup, approvals, reminders…"
          onChange={(event) => { setSearch(event.target.value); setTopic(""); }} />
      </label>
      <nav className="portal-guide-topics" aria-label={`${guide.title} topics`}>
        <button type="button" aria-pressed={!topic} onClick={reset}>All topics</button>
        {guide.sections.map((section) => (
          <button type="button" key={section.id} aria-pressed={topic === section.id}
            onClick={() => { setSearch(""); setTopic(section.id); }}>{section.title}</button>
        ))}
      </nav>
      <p className="portal-guide-result" role="status">{sections.length} of {guide.sections.length} topics shown</p>
      {sections.length ? sections.map((section) => (
        <section className="portal-guide-card" key={section.id}>
          <h4>{section.title}</h4>
          {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </section>
      )) : <div className="portal-guide-empty"><p>No topics match your search. Try a different word or view all topics.</p><button type="button" onClick={reset}>Clear search</button></div>}
      {showDocumentationLink && <a className="portal-guide-doc-link" href={`/UsageInfo#${guideKey === "cipc" ? "24" : "25"}`}>Open detailed notes in UsageInfo ↗</a>}
    </div>
  );
}
